import { render, staticRenderFns } from "./ShopBucket.vue?vue&type=template&id=7a2bb3f0&scoped=true&"
import script from "./ShopBucket.vue?vue&type=script&lang=js&"
export * from "./ShopBucket.vue?vue&type=script&lang=js&"
import style0 from "./ShopBucket.vue?vue&type=style&index=0&id=7a2bb3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2bb3f0",
  null
  
)

export default component.exports